<template>
	<el-dialog
		append-to-body
		top="10vh"
		:width="dialogWidth"
		:title="dialogTitle"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		@close="close"
	>
		<div style="margin-top:-20px;"></div>
		<template v-if="printBefore">
			<div>
				<div v-for="list in invoiceList" :key="list.invoiceNo" class="invoice_list">
					<div class="invoice_item">
						<span>{{$t('print.printInvoiceNo')}}：</span>
						{{ list.invoicesNo }}
					</div>
					<div class="invoice_item" v-if="printType=='1'">
						<span>{{$t('print.printCount')}}：</span>
						<el-input-number v-model="list.number" size="small" :min="0" :max="10"></el-input-number>
					</div>
				</div>
			</div>
      <div class="invoice_item" style="margin-bottom: 20px">
        <span><i>*</i>{{$t('print.printContent')}}：</span>
        <el-radio-group v-model="printType" @input="inputChange">
          <el-radio  label="1">{{$t('print.printContent')}}</el-radio>
          <el-radio  label="2">{{$t('print.printOneFace')}}</el-radio>
          <el-radio  label="3">{{$t('print.printOneOut')}}</el-radio>

        </el-radio-group>
      </div>
			<div class="invoice_item">
				<span><i>*</i>{{$t('print.printDevice')}}：</span>
				<el-select v-model="printerName" size="small" :placeholder="$t('print.pleaseSelectPrint')">
					<el-option :value="item.deviceName" :label="item.deviceName" v-for="item in pluginList"
							   :key="item.deviceName"></el-option>
				</el-select>
			</div>
			<span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('print.printCancel')}}</el-button>
                <el-button type="primary" :loading="loading" :disabled="loading" @click="beforeSurePrint">{{$t('print.printSure')}}</el-button>
            </span>
		</template>

		<template v-else>
      <div v-if="this.printType=='1'">
        <div v-if="invoiceList.length > 1" class="print_preview">
                <span
                  v-for="(item, index) in invoiceList"
                  :key="index"
                  :style="{background: item.invoicesNo === priveSn ? '#067cf2' : '#aaa'}"
                  @click="priveSn = item.invoicesNo">
                    {{ item.invoicesNo }}
                </span>
        </div>
        <div v-for="(item, index) in invoiceList" :key="index" style="overflow:hidden;">
          <webview
            style="width:100%;float:left;"
            :style="priveSn === item.invoicesNo && item.src ? 'height:500px;' : 'height:0;'"
            :src="item.src"></webview>
        </div>
      </div>
      <div v-else-if="this.printType=='2'">
        <div v-if="packageInvoiceList.length > 1" class="print_preview">
                <span
                  v-for="(item, index) in packageInvoiceList"
                  :key="index"
                  :style="{background: item.packageSn === packagePriveSn ? '#067cf2' : '#aaa'}"
                  @click="packagePriveSn = item.packageSn">
                    {{ item.packageSn }}
                </span>
        </div>
        <div v-for="(item, index) in packageInvoiceList" :key="index" style="overflow:hidden;">
          <webview
            style="width:100%;float:left;"
            :style="packagePriveSn === item.packageSn && item.src ? 'height:500px;' : 'height:0;'"
            :src="item.src"></webview>
        </div>
      </div>
      <div v-else>
        <div v-if="outPackageInvoiceList.length > 1" class="print_preview">
                <span
                  v-for="(item, index) in outPackageInvoiceList"
                  :key="index"
                  :style="{background: item.packageSn === packagePriveSn ? '#067cf2' : '#aaa'}"
                  @click="packagePriveSn = item.packageSn">
                    {{ item.packageSn }}
                </span>
        </div>
        <div v-for="(item, index) in outPackageInvoiceList" :key="index" style="overflow:hidden;">
          <webview
            style="width:100%;float:left;"
            :style="packagePriveSn === item.packageSn && item.src ? 'height:500px;' : 'height:0;'"
            :src="item.src"></webview>
        </div>
      </div>


		</template>
	</el-dialog>
</template>

<script>
import request from "@/libs/http";
import {ipc} from "@/utils/ipcRenderer";
import {ipcApiRoute} from "@/api/main";

export default {
	props: {
		modalParams: {//勾选单据列表
			type: Array,
			default: () => []
		},
		printKey: {//打印单id
			type: String,
			default: () => 'id'
		},
		printTemplate: {//打印模板
			type: String,
			default: () => 'DPTCD'
		},
		defaultCopies: {//默认打印份数
			type: String,
			default: () => '1'
		},
    documentType:{//区分打印单据来源TC||DB
      type: String,
      default: () => ''
    }
	},
	data() {
		return {
			loading: false,
			dialogVisible: true,
			printBefore: true,
			dialogTitle: this.$t('print.printSetTitle'),
			priveSn: '',
      packagePriveSn:'',
			invoiceList: [],
      packageInvoiceList:[],
      outPackageInvoiceList:[],
			dialogWidth: '940px',
			printerName: '',
			pluginList: [],
      printType:'1',
      packageTemplateCode:'',
      packageTemplateCount:'',


      packageOutTemplateCode:'',
      packageOutTemplateCount:''
		}
	},
	created() {
		this.printerName = this.$cache.local.get('printerModel');
		ipc.invoke(ipcApiRoute.getPrinters, {}).then(list => {
			this.pluginList = list
		})
    // 如果是打印包裹单的话 则根据单据类型走这里来获取缓存模版
    if (this.documentType=='DPTC') {
      this.packageTemplateCode = this.$cache.local.get('packageCode');
      this.packageTemplateCount=this.$cache.local.get('packageCount')

      // 外箱模版缓存
      this.packageOutTemplateCode = this.$cache.local.get('deptReturnPackageWDCode');
      this.packageOutTemplateCount=this.$cache.local.get('deptReturnPackageWDCount')
    }else {
      this.packageTemplateCode = this.$cache.local.get('deptAllotPackageCode');
      this.packageTemplateCount=this.$cache.local.get('deptAllotPackageCount')
// 外箱模版缓存
      this.packageOutTemplateCode = this.$cache.local.get('deptAllotPackageWDCode');
      this.packageOutTemplateCount=this.$cache.local.get('deptAllotPackageWDCount')
    }
		this.priveSn = this.modalParams[0].sn;
		this.invoiceList = this.modalParams.map(item => {
			return {
				invoicesNo: item.sn,
				id: item[this.printKey],
				number: this.defaultCopies
			}
		})
    this.modalParams.forEach(param => {
      if (param.packageInfoList?.length) {
        const packageItems = param.packageInfoList.map(item => ({
          invoicesNo: param.sn,
          id: param[this.printKey],
          packageId: item.packageId,
          packageSn: item.packageSn
        }));

        this.packageInvoiceList.push(...packageItems.map(item => ({
          ...item,
          number: this.packageTemplateCount
        })));

        this.outPackageInvoiceList.push(...packageItems.map(item => ({
          ...item,
          number: this.packageOutTemplateCount
        })));
      }
    });
    this.packagePriveSn=this.packageInvoiceList[0]?.packageSn;
	},
	methods: {
		close() {
			this.dialogVisible = false
			this.$emit('close')
		},
    beforeSurePrint() {
      if (!this.printerName) {
        return this.$message({type: 'error', message: this.$t('print.pleaseSelectPrint'), duration: 2000, showClose: true});
      }

      if(this.printType==='1') {
        this.surePrint()
      }else if(this.printType==='2'){
        let list=[]
        this.modalParams.forEach(item=> {
          if(!item.packageInfoList?.length) {
            list.push(item.sn)
          }
        })
        if(list.length) {
          return this.$message({type: 'error', message: this.$t('print.notPackagePickUp', {list: list.join(',')}), duration: 2000, showClose: true});
        }
        this.packageSurePrint()
      }else {
        let list=[]
        this.modalParams.forEach(item=> {
          if(!item.packageInfoList?.length) {
            list.push(item.sn)
          }
        })
        if(list.length) {
          return this.$message({type: 'error', message: this.$t('print.notPackagePickUp', {list: list.join(',')}), duration: 2000, showClose: true});
        }
        this.packageOutSurePrint()

      }

    },
    inputChange(e) {
      if(e=='2') {
      }

    },

		surePrint() {
			this.loading = true;
			let rootUrl = `${request.printPreviewRoot}?printerName=${this.printerName}&templateCode=${this.printTemplate}&`
			let eggRootUrl = `${request.printEggPreviewRoot}?printerName=${this.printerName}&templateCode=${this.printTemplate}&`
			this.invoiceList.forEach(item => {
				let params = {
					id: item[this.printKey]
				}
				item.src = rootUrl + `printCount=0&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`
				const eggSrc = eggRootUrl + `printCount=${item.number}&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`;
				ipc.invoke(ipcApiRoute.print, {contentUrl: eggSrc, sn: item['invoicesNo']}).then(r => {})
			})
			this.printBefore = false;
			this.loading = false;
			this.dialogWidth = '400px';
			this.dialogTitle = this.$t('print.printing');
		},
    packageOutSurePrint() {
      this.loading = true;
      let rootUrl = `${request.printPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageOutTemplateCode}&`
      let eggRootUrl = `${request.printEggPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageOutTemplateCode}&`
      this.outPackageInvoiceList.forEach(item => {
        let params = {
          id: item['packageId']
        }
        item.src = rootUrl + `printCount=0&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`
        const eggSrc = eggRootUrl + `printCount=${item.number}&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`;

        ipc.invoke(ipcApiRoute.print, {contentUrl: eggSrc, sn: item['invoicesNo']}).then(r => {})
      })
      this.printBefore = false;
      this.loading = false;
      this.dialogWidth = '400px';
      this.dialogTitle = this.$t('print.printing');
    },

    packageSurePrint() {
      this.loading = true;
      let rootUrl = `${request.printPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageTemplateCode}&`
      let eggRootUrl = `${request.printEggPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageTemplateCode}&`
      this.packageInvoiceList.forEach(item => {
        let params = {
          id: item['packageId']
        }
        item.src = rootUrl + `printCount=0&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`
        const eggSrc = eggRootUrl + `printCount=${item.number}&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`;
        ipc.invoke(ipcApiRoute.print, {contentUrl: eggSrc, sn: item['invoicesNo']}).then(r => {})
      })
      this.printBefore = false;
      this.loading = false;
      this.dialogWidth = '400px';
      this.dialogTitle = this.$t('print.printing');
    }
	}
}
</script>

<style lang="scss" scoped>
.invoice_list {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.invoice_item {
	display: flex;
	align-items: center;
	flex: 1;

	span {
		width: 200px;

		i {
			color: red;
			margin-right: 4px;
		}
	}
}

.print_preview {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	text-align: center;
	color: #fff;
	margin-bottom: 10px;

	span {
		height: 20px;
		background: #aaa;
		border-radius: 4px;
		margin-right: 10px;
		cursor: pointer;
		padding: 0 8px;
		margin-bottom: 5px;
	}
}
</style>
